import UserErrorFragment from './UserErrorFragment'
import CheckoutUserErrorFragment from './CheckoutUserErrorFragment'
import CheckoutFragment from './CheckoutFragment'

export default `
${UserErrorFragment}
${CheckoutUserErrorFragment}
${CheckoutFragment}
mutation ($checkoutId: ID!, $lineItemIds: [ID!]!) {
  checkoutLineItemsRemove(checkoutId: $checkoutId, lineItemIds: $lineItemIds) {
    userErrors {
      ...UserErrorFragment
    }
    checkoutUserErrors {
      ...CheckoutUserErrorFragment
    }
    checkout {
      ...CheckoutFragment
    }
  }
}`
